import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  show(event) {
    const index = parseInt(event.params.index)

    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add('border-[#C4A484]', 'text-[#C4A484]')
        tab.classList.remove('border-transparent', 'text-[#8C8C8C]')
      } else {
        tab.classList.remove('border-[#C4A484]', 'text-[#C4A484]')
        tab.classList.add('border-transparent', 'text-[#8C8C8C]')
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle('hidden', i !== index)
    })
  }

  searchContacts(event) {
    const query = event.target.value.trim()
    const resultsDiv = document.getElementById('contact-search-results')

    if (query.length < 2) {
      resultsDiv.innerHTML = '<p class="text-sm text-[#8C8C8C] text-center py-4">Search contacts by name or email, or search outlets by name...</p>'
      return
    }

    const addForm = this.element.querySelector('form[action*="release_contacts"]')
    const releaseId = addForm ? addForm.action.match(/releases\/(\d+)/)?.[1] : null

    fetch(`/pr/contacts/search?q=${encodeURIComponent(query)}&release_id=${releaseId || ''}`, {
      headers: { 'Accept': 'application/json' }
    })
    .then(response => response.json())
    .then(data => {
      if (data.length === 0) {
        resultsDiv.innerHTML = '<p class="text-sm text-[#8C8C8C] text-center py-4">No contacts or outlets found.</p>'
        return
      }

      const csrfToken = document.querySelector('meta[name=csrf-token]')?.content || ''

      resultsDiv.innerHTML = data.map(item => {
        if (item.type === 'outlet') {
          // Outlet group card with contacts listed inside
          const contactsHtml = item.contacts && item.contacts.length > 0
            ? item.contacts.map(c => `
                <div class="flex items-center justify-between py-2 px-3 hover:bg-[#8BA4B4]/5 rounded">
                  <div>
                    <p class="text-sm font-medium text-[#2D2D2D]">${c.name}${c.dnd ? ' <span class="px-1.5 py-0.5 text-[10px] rounded bg-[#E57373]/20 text-[#E57373] ml-1">DND</span>' : ''}</p>
                    <p class="text-xs text-[#8C8C8C]">${c.email || 'No email'}</p>
                    ${c.conflict ? `<p class="text-xs text-[#FFB74D] mt-0.5">Also on: ${c.conflict}</p>` : ''}
                  </div>
                  ${c.already_added
                    ? '<span class="text-xs text-[#8C8C8C] bg-[#F5F3F0] px-2 py-1 rounded">Already added</span>'
                    : `<form action="/pr/releases/${releaseId}/release_contacts" method="post" data-turbo="false">
                        <input type="hidden" name="authenticity_token" value="${csrfToken}">
                        <input type="hidden" name="contact_id" value="${c.id}">
                        <button type="submit" class="text-sm text-[#9CAF88] hover:text-[#7A9470] font-medium">+ Add</button>
                      </form>`
                  }
                </div>
              `).join('')
            : '<p class="text-xs text-[#8C8C8C] px-3 py-2">No contacts on file for this outlet.</p>'

          return `
            <div class="rounded-lg border border-[#8BA4B4]/30 bg-[#8BA4B4]/5 overflow-hidden">
              <div class="flex items-center justify-between p-3 border-b border-[#8BA4B4]/20">
                <div>
                  <p class="font-medium text-[#2D2D2D]">
                    <span class="text-xs bg-[#8BA4B4]/20 text-[#8BA4B4] px-1.5 py-0.5 rounded mr-2">Outlet</span>
                    ${item.name}
                  </p>
                  <p class="text-xs text-[#8C8C8C] mt-1">${(item.outlet_type || item.outlet_types_display || 'Publication')} · ${item.contacts ? item.contacts.length : 0} contact${item.contacts && item.contacts.length !== 1 ? 's' : ''}</p>
                </div>
                <a href="/pr/outlets/${item.id}" class="text-xs text-[#8BA4B4] hover:underline">View Outlet</a>
              </div>
              <div class="divide-y divide-[#8BA4B4]/10">
                ${contactsHtml}
              </div>
            </div>
          `
        }

        // Direct contact result
        const outletLabel = item.outlet ? `· ${item.outlet}` : ''

        return `
          <div class="flex items-center justify-between p-3 rounded-lg border border-[#E8E4DF] hover:bg-[#F5F3F0]">
            <div>
              <p class="font-medium text-[#2D2D2D]">${item.name}${item.dnd ? ' <span class="px-1.5 py-0.5 text-[10px] rounded bg-[#E57373]/20 text-[#E57373] ml-1">DND</span>' : ''}</p>
              <p class="text-sm text-[#8C8C8C]">${item.email || ''} ${outletLabel}</p>
              ${item.conflict ? `<p class="text-xs text-[#FFB74D] mt-1">Also on: ${item.conflict}</p>` : ''}
            </div>
            ${item.already_added
              ? '<span class="text-xs text-[#8C8C8C] bg-[#F5F3F0] px-2 py-1 rounded">Already added</span>'
              : `<form action="/pr/releases/${releaseId}/release_contacts" method="post" data-turbo="false">
                  <input type="hidden" name="authenticity_token" value="${csrfToken}">
                  <input type="hidden" name="contact_id" value="${item.id}">
                  <button type="submit" class="text-sm text-[#9CAF88] hover:text-[#7A9470] font-medium">+ Add</button>
                </form>`
            }
          </div>
        `
      }).join('')
    })
    .catch(() => {
      resultsDiv.innerHTML = '<p class="text-sm text-[#E57373] text-center py-4">Search failed. Please try again.</p>'
    })
  }
}
